import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api, { formatError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Navbar";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      const u = await login(email, password);
      toast.success("Willkommen zurück!");
      if (["admin", "branch_manager", "event_manager", "marketing_manager"].includes(u.role)) navigate("/admin");
      else if (u.role === "employee") navigate("/scanner");
      else if (u.role === "event_user") navigate("/veranstaltungen");
      else navigate("/mein-konto");
    } catch (e2) { setErr(formatError(e2.response?.data?.detail) || e2.message); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-md">
        <div className="text-center mb-6"><Logo className="justify-center" /></div>
        <div className="bg-white rounded-2xl border border-gray-100 p-8 shadow-sm">
          <h1 className="text-2xl font-bold font-display">Anmelden</h1>
          <p className="text-sm text-gray-500 mt-1">Willkommen zurück bei HELIUM.</p>
          <form onSubmit={submit} className="mt-6 space-y-4">
            <input required type="email" placeholder="E-Mail" data-testid="login-email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full px-4 py-3 rounded-xl border border-gray-200" />
            <input required type="password" placeholder="Passwort" data-testid="login-password" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full px-4 py-3 rounded-xl border border-gray-200" />
            {err && <div className="text-sm text-[#E0243A]" data-testid="login-error">{err}</div>}
            <button disabled={loading} data-testid="login-submit" className="w-full bg-[#E0243A] hover:bg-[#C81E33] text-white font-semibold py-3 rounded-xl disabled:opacity-60">{loading ? "Anmelden…" : "Anmelden"}</button>
          </form>
          <div className="mt-4 flex items-center justify-between text-sm">
            <Link to="/passwort-vergessen" className="text-gray-500 hover:text-[#E0243A]">Passwort vergessen?</Link>
            <Link to="/registrieren" className="text-[#E0243A] font-semibold">Konto erstellen</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
